<template>
  <div class="fleet-form-main">
          <div :class="`loader${loaderClass}`" v-show="loading">
          </div>
          <div id="page-content-wrapper" class="admin-content-area">
              <template v-if="cantAccessPage === true">
                  <div class="page-name">
                      <div class="page-title"> Debt Payment Reconciliation</div>
                      <a href="javascript:void(0)" class="btn btn-secondary pull-right" v-on:click="exportCheck()">
                          <i class="fp-export"></i> Export
                      </a>
                      <a v-if="canAccessPostSchedule == true" href="javascript:void(0)" class="btn btn-primary pull-right mr-3" v-on:click="addReconciliation()">
                          <i class="fp-add"></i> Create Reconciliation
                      </a>
                  </div>

                  <div class="container-fluid">
                    <div class="admin-page-content billing-forcast-report">

                        <section v-show="newSearch" class="bg-white mb-3">
                            <form class="form-horizontal basic-form-container contract-mapper" id="ContractAssetDetailForm">
                                <div class="form-row row-cols-md-4 row-cols-1">

                                    <div class="col-md-2 form-group">
                                          <label class="control-label require">Reconciliation Date</label>
                                          <div class="input-group">
                                              <date-picker placeholder="MM/DD/YYYY" id="rec_date" name="rec_date" v-model="rec_date"
                                              :config="optionsDate"
                                              aria-describedby="basic-addon3" class="cal-icon" @input="onRecDateChange()"></date-picker>
                                              <label for="rec_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                          </div>
                                          <div class="field-error">{{rec_date_error_msg}}</div>
                                    </div>


                                    <div class="col-md-3 form-group">
                                        <label class="control-label require" for="contractTypeId">Financier:</label>
                                        <v-select v-model="vendor_id" name="vendor_id" label="text" :filterable="false"
                                        :options="vendorArr" @search="onSearchVendor"
                                        placeholder="Select Vendor Code or Name" class="custom-ci-auto-search">
                                                <template slot="no-options">
                                                    Search Financier Code or Name...
                                                </template>
                                                <template slot="option" slot-scope="option">
                                                    <div class="d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                                <template slot="selected-option" slot-scope="option">
                                                    <div class="selected d-center">
                                                        {{ option.text }}
                                                    </div>
                                                </template>
                                        </v-select>
                                        <div class="field-error">{{vendor_error_msg}}</div>
                                    </div>


                                    <div class="col-md-4 form-group">
                                        <label class="control-label"></label>
                                        <div class="input-group">

                                            <button type="button" id="resetBtn" class="btn btn-secondary mr-2" v-on:click="getDebtPaymentReconciliation" >
                                                <i class="fp-accounting"> </i> Fetch
                                            </button>
                                            <button type="button" id="resetBtn" class="btn btn-secondary mr-2" v-on:click="resetFilters" >
                                                <i class="fp-reload"> </i> Reset
                                            </button>
                                            <button type="button" id="resetBtn" class="btn btn-secondary mr-2" v-on:click="closeReconciliation" >
                                                <i class="fp-close"> </i> Close
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <p v-if="batchProcess1" class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNum1}} is processing please wait!</p>
                                <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                            </form>
                        </section>

                        <div v-show="!newSearch" class="data-table bg-white">
                              <data-table-filter-config :moduleName="'debtPaymentReconciliation'" ref="debtPaymentReconciliation" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                              <div class="data-table bg-white overflow-hidden">
                                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :position="'top'"
                                        :moduleName="'debtPaymentReconciliation'" ref="paginateComponent">
                                </custom-pagination>

                                <vue-good-table
                                    ref="debtPaymentReconciliationTbl"
                                    mode="remote"
                                    title="Debt Payment Reconciliation"
                                    @on-page-change="onPageChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-cell-click="onRowClick"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :sort-options="{
                                        enabled: false
                                    }"
                                    :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }">

                                    <div slot="selected-row-actions">
                                          <button id="deleteBtn" v-on:click.prevent="removeDebtNoteRecon" class="btn btn-danger">Delete</button>
                                          <button v-if="canUnpost" id="unpostBtn" v-on:click.prevent="unPost" class="btn btn-primary">Unpost</button>
                                      </div>
                                    <!--template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                          <div v-if="props.column.field == 'note_amount' || props.column.field == 'principal_payment' || props.column.field == 'interest'">
                                              <div style="text-align: right;">
                                                {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                          <div v-else>
                                              {{props.formattedRow[props.column.field]}}
                                          </div>
                                        </div>
                                    </template-->


                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange"
                                        :moduleName="'debtPaymentReconciliation'">
                                </custom-pagination>
                              </div>
                        </div>


                    </div>
                  </div>

                </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
  </div>
</template>

<script>
import Vue from "vue";


import {commonMixins} from '../../mixins/commonMixins';
import {contractMixins} from '../../mixins/contractMixins';

import {dataTableMixins} from '../../mixins/dataTableMixins';
import EventBus from ".././event-bus";
import moment from 'moment';
let msgServer;
export default {
      name: "billingForcastReport",
      mixins:[commonMixins,contractMixins,dataTableMixins],
      metaInfo() {
          return {
              title: "Debt Payment Reconciliation | " +process.env.COPYRIGHT_NAME
          }
      },
      data: () => ({
        newSearch: false,
        firstLoad: 0,
        permissions: [],
        cantAccessPage: '',
        loading:false,
        vendorArr: [],
        vendor_id: '',
        vendor_error_msg: '',
        userColumns:[],
        columns: [
            {
                label: 'Posting Date',
                field: 'posting_date',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Posting Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable: true
            },
            {
                label: 'Posting Run Number',
                field: 'posting_run_number',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Posting Run Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Posting Amount',
                field: 'posting_amount',
                filterable: true,
                fpFieldType:"integer",
                type:"number",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Posting Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Financier',
                field: 'financier',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Financier", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
            {
                label: 'Status',
                field: 'status',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Status", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter", //only trigger on enter not on keyup
                    filterDropdownItems:["Complete","In Progress"]
                },
            },
            {
                label: 'Created By',
                field: 'created_by',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
            },
        ],
        rows: [],
        totalRecords: 0,
        optionsDate:{
            format: 'MM/DD/YYYY',
            useCurrent: false,
            maxDate: new Date(),
        },
        // configEnd: {
        //     wrap: true, // set wrap to true only when using 'input-group'
        //     altFormat: 'm/d/Y G:i K',
        //     altInput: true,
        //     dateFormat: 'Y-m-d H:i:S',
        //     enableTime: true,
        //     minDate: null
        //     //locale: Hindi, // locale for this instance only
        // },
        rec_date: moment(new Date()).format('MM/DD/YYYY'),
        rec_date_error_msg: '',
        batchProcess1:false,
        batchProcess:0,
        batchNum:"",
        batchError:false,
        batchErrorMsg:"",
        canUnpost: false,
      }),
      watch:{

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_debt_note_reconciliation') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'debt_note_post_schedule') {
                            self.canAccessPostSchedule = true;
                        }
                        if (permissions[i].name == 'unpost_gl'){
                          self.canUnpost = true;
                        }
                    }
                }

            }
      },
      created : function () {
          let self = this;
      },
      beforeDestroy() {
          // Make sure to close the connection with the events server
          // when the component is destroyed, or we'll have ghost connections!
          msgServer.close();
      },
      mounted: function() {
          var self = this;
          self.getPermissions();
          // if(self.firstLoad > 0) {
          //   self.loadList();
          // }
      },
      methods: {

          exportCheck: function() {
              var self = this;
              var count = 0;
              var actionFlag = "";
              var data = this.$refs['debtPaymentReconciliationTbl'].selectedRows;
              count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

              this.exportReports(actionFlag);
          },
          addReconciliation: function() {
            var self = this;
            self.newSearch = true;
          },
          closeReconciliation: function() {
            var self = this;
            self.newSearch = false;
          },
          cancelAll: function (cancelAll) {
            this.$refs.debtPaymentReconciliationTbl.unselectAllInternal();
          },
          resetFilters() {
              this.vendor_id = '';
              this.vendorArr = [];
              this.rec_date = '';
          },
          getDebtPaymentReconciliation() {
            var self = this;
            var error = false;

            self.vendor_error_msg = '';
            self.rec_date_error_msg = '';

            if ( self.vendor_id == '' && !self.vendor_id.value ) {
                  self.vendor_error_msg = "Please select Financier";
                  error = true;
            }

            if ( self.rec_date == '' || self.rec_date == null ) {
                  self.rec_date_error_msg = "Please select Date";
                  error = true;
            }

            if(!error) {
              self.getDetail();
            }

          },
          onSearchVendor(search, loading) {
              var self = this;
              self.vendor_error_msg = "";
              if (search.length > 2) {

                  loading(true);
                  self.searchField(loading, search, 'vendor_financier', '');
              }
          },
          onRowClick(params,event) {

              var self = this;

              if(self.canAccessPostSchedule == true) {
                if ( params.row.id > 0 &&  params.row.posting_run_number > 0) { //
                    self.$router.push('/debtpayment/reconciliation/view/' + params.row.id);
                }
                if(params.row.posting_run_number == 0) {
                    self.$swal('','Reconciliation Schedules not available','info');
                }
              }

              /*else {
                  alert("No Record Found.");
              }*/


          },
          unPost(){
            var self = this;
            var data = self.$refs['debtPaymentReconciliationTbl'].selectedRows;
            if (data.length > 1){
              self.$swal({
                title: 'You can only reverse one debt payment at a time.',
                type: 'error',
                showCancelButton: true,
                cancelButtonText: 'Ok',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                showConfirmButton: false
              });
            }else{
              var selectedRows = [];

              for (var i = 0; i < data.length; i++) {
                if (data[i].status.toLowerCase() != 'complete'){
                  self.$swal('','Please select records with Complete status','info');
                  return;
                }
                selectedRows.push(data[i])
              }
            }
            if(self.canAccessPostSchedule == true) {
              if ( selectedRows[0].id > 0 &&  selectedRows[0].posting_run_number > 0) { //
                self.$router.push('/debtpayment/reconciliation/view/' + selectedRows[0].id);
              }
              if(selectedRows[0].posting_run_number == 0) {
                self.$swal('','Reconciliation Schedules not available','info');
              }
            }
          },
          onRecDateChange() {
              var self = this;
              console.log("DATE CHANGES");
              self.daysError = "";
              // if (self.rec_date != "" && self.rec_date != null) {
              //     // self.days = "";
              // }
              console.log("ddd ==", self.rec_date);
          },
          getFormattedDate(todayTime) {
            // var todayTime = new Date();
            var month = format(todayTime .getMonth() + 1);
            var day = format(todayTime .getDate());
            var year = format(todayTime .getFullYear());
            return year  + "/" +month + "/" + day;
          },

          getDetail() {
              var self = this;

              var filterArr = {};
              self.loading = true;
              var fields = {
                  financier:self.vendor_id.value,
                  rec_date: self.rec_date,
              };
              self.firstLoad = 1;
              $.ajax({
                  url: process.env.ROOT_API + "/debtpayment/reconciliation",
                  type: "POST",
                  data: fields,
                  headers: this.ajxHeaders,
                  dataType: "json",
                  success: function (data) {
                      self.loading = false;

                      if (data.status == "success") {
                          self.batchId = data.batchId;
                          self.batchNum1 = data.batchNumber;
                          self.batchProcess1 = true;
                          self.checkBatchStatus();
                      }else{
                          self.batchProcess1 = true;
                          self.batchId = data.batchId;
                          self.checkBatchStatus();
                          setTimeout(function(){
                              $("#processFetchBatchMsg").text('');
                              $("#processFetchBatchMsg").text(data.message);
                          },100);
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      if (jqXHR.status == 0) {
                          self.errorMsg = "Remote server cannot be reached";
                      } else {
                          //redirect to login page if user not authenticated
                          if (jqXHR.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("tkn");
                              self.$router.push("/");
                          }
                          self.error = jqXHR.responseJSON.message;
                      }
                  }
              });
          },
          checkBatchStatus:function(){
                var self =  this;
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess1 = false;
                            self.loadList();
                            sse.close();

                        }else if (data.status == "2") {
                            self.batchProcess1 = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });
          },
          loadList() {

              var self = this;

              var data = self.$refs['debtPaymentReconciliationTbl'].selectedRows;
              var selectedRows = [];

              for (var i = 0; i < data.length; i++) {
                  selectedRows.push(self.$refs['debtPaymentReconciliationTbl'].selectedRows[i].id)
              }

              var filterArr = {};

              self.loading = true;
              var fields = {
                  page: self.serverParams.page,
                  perPage: self.serverParams.perPage,
                  filters: self.serverParams.columnFilters,
                  sort: self.serverParams.sort,
                  flag: self.flag,
                  all:self.serverParams.selectedAll,
                  selectedRows:selectedRows,
                  action:self.action
              };
              self.firstLoad = 1;
              $.ajax({
                  url: process.env.ROOT_API + "/debtpayment/list",
                  type: "POST",
                  data: fields,
                  headers: this.ajxHeaders,
                  dataType: "json",
                  success: function (data) {
                      self.loading = false;

                      if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();
                          }else{
                              self.newSearch = false;
                              self.rows = data.content.row;
                              self.totalRecords = data.content.totalRecords;
                              self.lastUpdated = data.lastUpdatedAt;

                              if (data.batchId){
                                  self.batchId = data.batchId;
                                  self.batchNum1 = data.batch;
                                  self.batchProcess1 = true;
                                  self.checkBatchStatus();
                              }
                          }

                      }else{
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                          self.lastUpdated = data.lastUpdatedAt;
                          if (data.batchId){
                              self.batchId = data.batchId;
                              self.batchNum1 = data.batch;
                              self.batchProcess1 = true;
                              self.checkBatchStatus();
                          }
                      }
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      if (jqXHR.status == 0) {
                          self.errorMsg = "Remote server cannot be reached";
                      } else {
                          //redirect to login page if user not authenticated
                          if (jqXHR.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("tkn");
                              self.$router.push("/");
                          }
                          self.error = jqXHR.responseJSON.message;
                      }
                  }
              });

          },

          removeDebtNoteRecon:function(){
              var self = this;

              var data = self.$refs['debtPaymentReconciliationTbl'].selectedRows;
              var selectedRows = [];

              for (var i = 0; i < data.length; i++) {
                  if (data[i].status.toLowerCase() != 'in progress'){
                      self.$swal('','Please select records with in progress status','info');
                      return;
                  }
                  selectedRows.push(self.$refs['debtPaymentReconciliationTbl'].selectedRows[i].id)
              }

              self.loading = true;
              $.ajax({
                  url: process.env.ROOT_API + "/debtpayment/reconciliation/delete",
                  type: "POST",
                  data: {ids:selectedRows},
                  headers: this.ajxHeaders,
                  dataType: "json",
                  success: function (data) {
                      self.loading = false;
                      self.$swal('','Debt Note Reconciliation Removed successfully','success');
                      self.cancelAll(true);
                      self.loadList();
                  },
                  error: function (jqXHR, exception) {
                      self.loading = false;
                      if (jqXHR.status == 0) {
                          self.errorMsg = "Remote server cannot be reached";
                      } else {
                          //redirect to login page if user not authenticated
                          if (jqXHR.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("tkn");
                              self.$router.push("/");
                          }
                          self.error = jqXHR.responseJSON.message;
                      }
                  }
              });


          }




        }

}
</script>



// WEBPACK FOOTER //
// src/components/payment/DebtPaymentReconciliation.vue